import { css } from '@emotion/react';
import { Secondary, p2r } from '../../styles/fonts';
import { colors, breakpoints } from '../../styles';

const { darkOrange, lightBlack, lightGray } = colors;

const styles = (backgroundColor, backgroundColorFooter) => css`
  color: ${lightBlack};

  .article__subtitle--yellow {
    color: ${darkOrange};
  }

  .article__posts-block-background {
    width: 100%;
    background-color: ${backgroundColor};
  }

  .article__posts-block-background-footer {
    width: 100%;
    background-color: ${backgroundColorFooter};
  }

  .article__posts-block-background--small-size {
    position: absolute;
    z-index: -1;
    min-height: ${p2r(339)};
  }

  .article__posts-block-quote {
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: ${breakpoints.tablet}px) {
      flex-direction: column;
    }
  }

  .article__block-in-center {
    display: flex;
    justify-content: center;
  }

  .article__posts-block-second {
    padding-bottom: ${p2r(32)};
  }

  .strong-word-section__text-container {
    padding: ${p2r(32)} 92px ${p2r(48)} 92px;
  }

  @media (max-width: ${breakpoints.tablet}px) {
    .article__posts-block-background--big-size,
    .article__posts-block-background--small-size {
      display: none;
    }

    .article__small-logo {
      padding-left: 18px;
      margin-bottom: ${p2r(16)};
    }

    .article__subtitle--yellow .text-subtitle {
      font-size: ${p2r(24)};
      line-height: ${p2r(32)};
    }

    .article__posts-block-first {
      background-color: ${lightGray};
    }
  }

  @media (max-width: ${breakpoints.smallTablet}px) {
    .article__navigation {
      display: none;
    }

    .article__small-logo-text,
    .article__small-logo-image-wrapper {
      display: block;
    }

    .article__small-logo-text {
      padding: 0 0 ${p2r(12)} 0;
      font-size: ${p2r(12)};
    }

    .article__small-logo-image-wrapper > div > a > img {
      max-width: 128px;
    }

    .article__small-logo-image-wrapper > div > a > img,
    .article__small-logo-image-wrapper > div {
      height: ${p2r(32)};
    }

    .article__posts-block-second .text__all-text--mobile {
      font: normal normal bold ${p2r(36)} / ${p2r(42)} ${Secondary};
    }

    .article__subtitle--yellow .text-subtitle {
      font-weight: bold;
    }
  }

  @media (max-width: ${breakpoints.mobile}px) {
    .article__subtitle--yellow .text-subtitle {
      font-size: ${p2r(28)};
      line-height: ${p2r(32)};
    }

    .article__posts-block-second {
      padding-bottom: ${p2r(64)};
    }
  }
`;

export default styles;
